<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    @click="openTab"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    service: {
      type: String,
      required: true,
    },

    id: {
      type: String,
      required: true,
    },
  },

  computed: {
    pageUrl() {
      return `${this.service}/${this.id}`;
    },
  },

  methods: {
    openTab() {
      window.open(this.pageUrl, '_blank');
    },
  },
};
</script>

<style scoped>

</style>
